import axios from "./constant";

axios.defaults.withCredentials = true;

export const getAssetsName = async (data) =>
  await axios
    .get("/assets_name")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getUserDetails = async (data) =>
  await axios
    .get("/get_user_details")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const assign_dealer = async (data) =>
  await axios
    .post("/assign_dealers", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const AddAssetsType = async (data) =>
  await axios
    .post("/new_asset", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const AddAssetsSubType = async (data) =>
  await axios
    .post("/new_asset_sub_type", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const CompletedRequirements = async (school_id, UDISE_code) =>
  await axios
    .get(
      `/completed_req_hostel?school_id=${school_id}&UDISE_code=${UDISE_code}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const hostelrejectRequirements = async (data) =>
  await axios
    .post("/rejected_req_hostel", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const hostelconfirmRequirements = async (data) =>
  await axios
    .post("/track_req_hostel", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const AddAsset = async (data) =>
  await axios
    .post("/new_inventory", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const createhostellogin = async (data) =>
  await axios
    .post("/create_hostel_login", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const AddExistingAsset = async (data) =>
  await axios
    .post("/update_inventory_asset", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const subassets = async (data) =>
  await axios
    .post("/get_amenities_sub_type", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const subassetsHO = async (data) =>
  await axios
    .post("/amenities_sub_type_master_amenity_wise", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const Assetnameinfo = async (data) =>
  await axios
    .post("/asset_name_nfo", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const CurrentQuantity = async (data) =>
  await axios
    .post("/get_asset_count", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const updateRequirement = async (data) =>
  await axios
    .post("/update_req", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const modifydetails = async (data) =>
  await axios
    .post("/update_modify", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const RejectRequirement = async (data) =>
  await axios
    .post("/update_reject_req", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const EditRequirement = async (data) =>
  await axios
    .post("/update_edit_req", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const received = async (data) =>
  await axios
    .post("/confirm_delivery", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const visitcheckout = async (data) =>
  await axios
    .post("/visit_check_out", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const insertUserDetails = async (data) =>
  await axios
    .post("/insert_crm_user", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const updateAssignedDealer = async (dealerId, data) => {
  try {
    const response = await axios.post(
      `/update_assigned_dealers/${dealerId}`,
      data
    );
    return response.data;
  } catch (error) {
    return "Error - " + error;
  }
};

export const updateUserDetails = async (data) => {
  return await axios
    .post("/update_profile", data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const updateBlockStatus = async (data) =>
  await axios
    .put("/update_block_status", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const changePassword = async (data) =>
  await axios
    .post("/change_password", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const updateMOMText = async (id, data) =>
  await axios
    .post(`/edit_mom/${id}`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const staffdetails = async (data) =>
  await axios
    .post("/get_staff_info", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const allhostellogin = async (data) =>
  await axios
    .get("/hostel_wise_data", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const assigneddealerreport = async (data) =>
  await axios
    .get("/assigned_dealers_history", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const newdealers = async (data) =>
  await axios
    .get("/visit_reports", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const meetingReport = async (data) =>
  await axios
    .get("/meeting_reports", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const checkIn = async (data) => {
  try {
    const response = await axios.post("/check_in", data);
    return response.data;
  } catch (error) {
    console.error("Error checking in:", error);
    return "Error - " + error;
  }
};

export const insertMom = async (formData) => {
  try {
    const response = await axios.post("/insert_mom", formData);
    return response.data;
  } catch (error) {
    console.error("Error inserting mom:", error);
    return "Error - " + error;
  }
};

export const checkOut = async (data) => {
  try {
    const response = await axios.post("/check_out", data);
    return response.data;
  } catch (error) {
    console.error("Error checking out:", error);
    return "Error - " + error;
  }
};

export const getalldealers = async (data) =>
  await axios
    .get("/get_available_dealers", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getbrandProduct = async (data) =>
  await axios
    .get("/get_brand_and_product", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const currentassigned = async (sales_person_id) =>
  await axios
    .get(`/view_current_assigned_dealers?sales_id=${sales_person_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const viewassigneddealers = async (sales_person_id) =>
  await axios
    .get(`/view_assigned_dealers?sales_id=${sales_person_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const dailycheckin = async () =>
  await axios
    .get(`/get_daily_check_in`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const allsalepersons = async (data) =>
  await axios
    .get("/get_all_sales_person", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const fetchIframe = async (dealer_user_id) => {
  try {
    const response = await axios.get(
      `/view_best_route_to_reach_dealer/${dealer_user_id}`
    );
    return response.data; // Assuming the response directly contains iframeURL
  } catch (error) {
    console.error("Error fetching dealer details:", error);
    return null; // Return null or handle error as needed
  }
};

export const dealerdetails = async (id) =>
  await axios
    .get(`/get_dealer_details_by_id/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const assignedhistory = async (ad_id) =>
  await axios
    .get(`/get_history_by_adId/${ad_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getMomText = async (momId) =>
  await axios
    .get(`/get_mom_text/${momId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const allUsers = async (data) =>
  await axios
    .get("/get_all_users", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const admindetails = async (id) =>
  await axios
    .get(`/get_admin/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const logoutApi = async (id) =>
  await axios
    .get(`/logout`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const insertDealer = async (id, data) =>
  await axios
    .post(`/insert_dealers/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

//new apis

export const getRequirements = async (data) =>
  await axios
    .post("/requirements", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getallDistricts = async () =>
  await axios
    .get("/get_all_districts")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getdistictName = async (data) =>
  await axios
    .get("/get_all_districts")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getGCB = async () =>
  await axios
    .get("/get_student_gbc_master")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getHostelWiseRequirements = async (requestData) => {
  try {
    const response = await axios.post("/hostel_wise_reqmnt_data", requestData);
    return response.data;
  } catch (error) {
    throw new Error("Error - " + error);
  }
};
// export const getAssetReport = async (requestData) => {
//   try {
//     const response = await axios.post("/get_asset_report", requestData);
//     return response.data;
//   } catch (error) {
//     throw new Error("Error - " + error);
//   }
// };
export const getAssetReport = async (requestData) => {
  try {
    const response = await axios.post("/get_asset_report", requestData);
    return response.data;
  } catch (error) {
    throw new Error("Error - " + error);
  }
};

export const getRejectedRequirements = async () =>
  await axios
    .get("/rejected_req")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getstudentinfo = async () =>
  await axios
    .post("/get_student_info")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getstaffinfo = async () =>
  await axios
    .post("/get_staff_info")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllStudents = async (data) =>
  await axios
    .post("/all_students", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const anwesha_dashboard_data = async () =>
  await axios
    .get("/anwesha_dashboard_data")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const AllStaff = async (data) =>
  await axios
    .post("/all_staff", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getSchoolData = async (data) =>
  await axios
    .post("/school_kpi_dashboard", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getHostelData = async (data) =>
  await axios
    .post("/hostel_kpi_dashboard", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllHostels = async () =>
  await axios
    .get("/get_all_hostels")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllAshram = async () =>
  await axios
    .get("/get_total_ashram")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardNewRequirements = async (data) =>
  await axios
    .post("/get_dashboard_new_requirement", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardPendingRequirements = async (data) =>
  await axios
    .post("/get_dashboard_pending_requirement", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardRejectedRequirements = async (data) =>
  await axios
    .post("/get_dashboard_rejected_requirement", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardCompletedRequirements = async (data) =>
  await axios
    .post("/get_dashboard_completed_requirement", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardAllRequirements = async (data) =>
  await axios
    .post("/get_dashboard_all_requirement", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getDashboardAllStudents = async () =>
  await axios
    .get("/get_total_school")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getUserAllStudents = async () =>
  await axios
    .get("/all_students")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getUserDashboardNewRequirements = async (data) =>
  await axios
    .post("/get_dashboard_new_requirement_hostel", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getUserDashboardPendingRequirements = async (data) =>
  await axios
    .post("/get_dashboard_pending_requirement_hostel", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getUserDashboardCompletedRequirements = async (data) =>
  await axios
    .post("/get_dashboard_completed_requirement_hostel", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getUserDashboardAllRequirements = async (data) =>
  await axios
    .post("/get_dashboard_all_requirement_hostel", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getPincode = async (data) => {
  try {
    const response = await axios.get(
      "https://api.postalpincode.in/pincode/" + data,
      {
        withCredentials: false,
      }
    );
    return response.data;
  } catch (error) {
    return "Error - " + error;
  }
};

export const addStudent = async (data) => {
  return await axios
    .post("/insert_student_details", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const updateStudent = async (data) => {
  return await axios
    .post("/update_student_info", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const addStaff = async (data) => {
  return await axios
    .post("/new_staff_info", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const updateStaff = async (data) => {
  return await axios
    .post("/update_staff_info", data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const getMapData = async () =>
  await axios
    .get("/get_map_data")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getHostelwiseStudents = async () =>
  await axios
    .get("/hostel_wise_students_count")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getHostelwiseStaff = async () =>
  await axios
    .get("/hostel_wise_staff_count")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAmenitiesType = async () =>
  await axios
    .get("/get_amenities_type")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllBlocksFromDistrict = async (District) =>
  await axios
    .get(`/get_block_from_district?district_code=${District}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getAllStatus = async (data) =>
  await axios
    .post(`/amenities_sub_type_status_wise`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getGPFromDistrictAndBlock = async (District, Block) =>
  await axios
    .get(
      `/get_gp_from_block_and_district?district_code=${District}&block_code=${Block}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getVillageFromGpBlockAndDistrict = async (District, Block, GP) =>
  await axios
    .get(
      `/get_village_from_gp_block_and_district?district_code=${District}&block_code=${Block}&gp_code=${GP}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getSchoolFromVillage = async (Village) =>
  await axios
    .get(`/get_school_name_gmid?gm_id=${Village}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAmenityCountsData = async (data) => {
  return await axios
    .post("/get_actual_ideal_shortage_count", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const getUrgentRequirements = async (data) => {
  return await axios
    .post("/get_urgent_requirements", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const getHostelCategory = async () =>
  await axios
    .get(`/get_hostel_category`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getHostelCategorySchoolWise = async (data) => {
  await axios
    .post("/get_hostel_category_school_wise", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const submitLimits = async (data) => {
  return await axios
    .post("/insert_limit_allocation_data", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const submitQuestion = async (postData) => {
  return await axios
    .post("/add_new_question", postData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const submitProgramQuestion = async (postData) => {
  return await axios
    .post("/add_new_program_question", postData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const get_year_of_const = async (data) => {
  return await axios
    .post("/get_year_of_const", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const assign_assit_head_master = async (data) => {
  return await axios
    .post("/assign_assit_head_master", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const requirements = async (data) => {
  return await axios
    .post("/requirements", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const get_limit_report = async (UDISE_code) =>
  await axios
    .get(`/get_limit_report/?UDISE_code=${UDISE_code}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const school_name_block_wise = async (data) => {
  return await axios
    .post("/school_name_block_wise", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const weo_approval = async (data) =>
  await axios
    .post("/weo_approval", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const head_office_secretary_approval = async (data) =>
  await axios
    .post("/head_office_secretary_approval", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_ashram_data_school_wise = async (data) =>
  await axios
    .post("/get_ashram_data_school_wise", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const show_confirm_delivery = async (data) =>
  await axios
    .post("/show_confirm_delivery", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const track_requirement = async (school_id, udise_code) =>
  await axios
    .get(`/track_requirement?school_id=${school_id}&UDISE_code=${udise_code}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const track_requirement_flags = async (data) =>
  await axios
    .post(`/track_requirement_flags`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_total_limit_used_balance = async (data) =>
  await axios
    .post(`/get_total_limit_used_balance`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const handleConfirmDelivery = async (data) =>
  await axios
    .post("/confirm_delivery", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const update_actual_count = async (data) =>
  await axios
    .post("/update_actual_count", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_legacy_data_report = async () =>
  await axios
    .get(`/get_legacy_data_report`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_hostel_type_from_udise = async (data) =>
  await axios
    .post("/get_hostel_type_from_udise", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_school_name_gmid = async (gm_id) =>
  await axios
    .get(`/get_school_name_gmid?gm_id=${gm_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_category_for_student = async () =>
  await axios
    .get(`/get_category_for_student`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_sub_category_for_student_by_caste = async (data) =>
  await axios
    .post("/get_sub_category_for_student_by_caste", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const newNotice = async (data) => {
  return await axios
    .post("/new_notice", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const get_new_notice_icon_count = async () =>
  await axios
    .post(`/get_new_notice_icon_count`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_unseen_notices = async () =>
  await axios
    .post(`/get_unseen_notices`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_new_guideline_icon_count = async () =>
  await axios
    .post(`/get_new_guideline_icon_count`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_unseen_guideline = async () =>
  await axios
    .post(`/get_unseen_guideline`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const download_notice_insert_view_log_api = async (data) =>
  await axios
    .post(`/download_notice_insert_view_log_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const dwo_approval = async (data) =>
  await axios
    .post("/dwo_approval", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const dm_approval = async (data) =>
  await axios
    .post("/dm_approval", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const teacher_profile = async (data) =>
  await axios
    .post("/teacher_profile", data, {})
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const student_profile = async (data) =>
  await axios
    .post("/student_profile", data, {})
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const show_all_notice_api = async (data) =>
  await axios
    .post(`/show_all_notice_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const show_all_notice_on_load = async (data) =>
  await axios
    .post(`/show_all_notice_on_load`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const show_all_guideline_api = async (data) =>
  await axios
    .post(`/show_all_guideline_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const newGuideline = async (data) => {
  return await axios
    .post("/new_guideline", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const district_wise_fund = async () =>
  await axios
    .get(`/district_wise_fund `)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const amenity_wise_req_kpi_dashboard = async (data) => {
  return await axios
    .post("/amenity_wise_req_kpi_dashboard", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const amenity_wise_shortage_count_kpi_dashboard = async (data) => {
  return await axios
    .post("/amenity_wise_shortage_count_kpi_dashboard", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const getFyFundAllocated = async () =>
  await axios
    .get("/get_fy_fund_allocated")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const insertFyBudget = async (data) =>
  await axios
    .post(`/insert_fy_budget`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const bulk_approval_show_api = async (data) =>
  await axios
    .post(`/bulk_approval_show_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const bulk_approval_view_all_api = async (data) =>
  await axios
    .post(`/bulk_approval_view_all_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const bulk_approval_accept_all_api = async (data) =>
  await axios
    .post(`/bulk_approval_accept_all_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const bulk_approval_api_weo = async (data) =>
  await axios
    .post(`/bulk_approval_api_weo`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const head_office_DD_approval = async (data) =>
  await axios
    .post(`/head_office_DD_approval`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const fund_recieved_dwo = async (data) =>
  await axios
    .post(`/fund_recieved_dwo`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const dwo_fullfillment = async (data) =>
  await axios
    .post(`/dwo_fullfillment/`, data)

    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const confirmDeliveryDwo = async (data) =>
  await axios
    .post(`/confirm_delivery_dwo`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const precurementInitialization = async (data) =>
  await axios
    .post(`/precurement_initialization`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const amenity_lifespan_uploads = async (data) =>
  await axios
    .post(`/amenity_lifespan_uploads`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const new_checklist = async (data) => {
  return await axios
    .post("/new_checklist", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const new_program = async (data) => {
  return await axios
    .post("/new_program", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};

export const get_confirmed_delivered_photo = async (UDISE_code) =>
  await axios
    .get(`/get_confirmed_delivered_photo?UDISE_code=${UDISE_code}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const allChecklist = async (data) =>
  await axios
    .post(`/get_all_checklist`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const allProgram = async (data) =>
  await axios
    .post(`/get_all_program`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getAllQuestions = async (id) =>
  await axios
    .get(`/get_all_checklist_questions?checklist_id=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllAnswers = async (id) =>
  await axios
    .get(`/checklist_report?checklist_id=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllProgramQuestions = async (id) =>
  await axios
    .get(`/get_all_program_questions?program_id=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const approvalApiDwo = async (data) =>
  await axios
    .post(`/approval_api_dwo`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const ask_fund_view_all_api = async (data) =>
  await axios
    .post(`/ask_fund_view_all_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const ask_fund_show_api = async (data) =>
  await axios
    .post(`/ask_fund_show_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const manage_amenities_lifespan = async (UDISE_code) =>
  await axios
    .get(`/manage_amenities_lifespan/?UDISE_code=${UDISE_code}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_lifespan_photo = async (UDISE_code) =>
  await axios
    .get(`/get_lifespan_photo/?UDISE_code=${UDISE_code}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const precurement_initialize = async (data) =>
  await axios
    .post(`/precurement_initialize`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const precurement_status = async (data) =>
  await axios
    .post(`/precurement_status`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const precurement_completed = async (data) =>
  await axios
    .post(`/precurement_completed`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const capture_checklist_answers = async (data) =>
  await axios
    .post(`/capture_checklist_answers`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const fundMasterType = async () =>
  await axios
    .get(`/fund_master_type`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const fundMasterSubType = async () =>
  await axios
    .get(`/fund_master_sub_type`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const fundUtilization = async (data) =>
  await axios
    .post(`/fund_utilization`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const ask_fund_forward = async (data) =>
  await axios
    .post(`/ask_fund_forward_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const capture_program_answers = async (data) =>
  await axios
    .post(`/capture_program_answers`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getAllProgramAnswers = async (id) =>
  await axios
    .get(`/program_report?program_id=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const checklist_inactive = async (data) =>
  await axios
    .post(`/checklist_inactive`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_all_active_checklist = async (data) =>
  await axios
    .post(`/get_all_active_checklist`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const get_all_active_program = async (data) =>
  await axios
    .post(`/get_all_active_program`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const program_inactive = async (data) =>
  await axios
    .post(`/program_inactive`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const class_api = async (data) =>
  await axios
    .post(`/class_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const section_api = async (data) =>
  await axios
    .post(`/section_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const subject_api = async (data) =>
  await axios
    .post(`/subject_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const assigment_upload_api = async (data) =>
  await axios
    .post(`/assigment_upload_api`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
